<template>
  <div class="container">
    <form
      name="test"
      style="margin: 0 auto; max-width: 700px;"
      @submit.prevent="onSubmit"
    >
      <base-text
        name="company"
        label="Company"
        v-model="base.company.name"
        :disabled="true"
      ></base-text>
      <base-text
        name="month"
        label="Month of processing"
        v-model="base.collection_date"
        :disabled="true"
      ></base-text>
      <base-text
        name="name"
        label="Product ID"
        v-model="base.name"
        :disabled="true"
      ></base-text>
      <base-text
        name="human_name"
        label="Product Name"
        v-model="base.human_name"
        :disabled="true"
      ></base-text>
      <base-text
        name="additives_percentage"
        label="Virgin & additives"
        :value="`${outputSecond.additives_percentage}%`"
        :disabled="true"
      ></base-text>
      <base-text
        name="other_percentage"
        label="Other materials"
        :value="`${outputSecond.other_percentage}%`"
        :disabled="true"
      ></base-text>

      <h4>Materials</h4>
      <table class="table table-hover table-sm">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Value</th>
            <th scope="col">Pre-C</th>
            <th scope="col">Post-C</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(material, index) in materials"
            :key="material.id"
          >
            <th scope="row">{{index + 1}}</th>
            <td>{{materialsMap[material.material_id]}}</td>
            <td>{{material.percentage}}%</td>
            <td>{{material.postindustrial}}%</td>
            <td>{{material.postconsumer}}%</td>
          </tr>
        </tbody>
      </table>
      <div v-if="otherMaterials.length > 0">
        <hr>
        <h4>Other materials</h4>
        <table class="table table-hover table-sm">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(material, index) in otherMaterials"
              :key="material.id"
            >
              <th scope="row">{{index + 1}}</th>
              <td>{{compositionsMap[material.sub_composition_id]}}</td>
              <td>{{material.percentage}}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button
            radius="bl"
            component-class="blue"
            @click.native="$router.go(-1)"
          >
            <i class="fas fa-arrow-left mr-3"></i> Previous
          </base-button>
        </div>
        <div class="col-6 text-right">
            <base-button
            radius="br"
            component-class="green filled"
            type="submit"
            >Save <i class="fas fa-arrow-right ml-3"></i>
            </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import BaseText from '@/components/inputs/text/BaseText';
  import BaseButton from '@/components/inputs/button/BaseButton';

  export default {
    data() {
      return {
        base: {
          company: { name: '' },
          country: { name: '' },
          collection_date: '',
          human_name: '',
          name: '',
        },
        outputSecond: {
            additives_percentage: 0,
            other_percentage: 0,
            materials: [],
            recycled_content: 0,
        },
        materials: [],
        otherMaterials: []
      };
    },
    computed: {
      ...mapState({
        baseData: state => state.submitWaste.baseData,
        outputSecondData: state => state.submitWaste.outputSecondData,
        companyCompositions: state => state.userCompositions.data,
        // materials: state => state.materials.materials,
      }),
      materialsMap() {
        const materialMap = {};
        this.$store.getters['materials/flatMaterials'].forEach((material) => {
          materialMap[material.id] = material.name;
        });
        return materialMap;
      },
      compositionsMap() {
        const compositionsMap = {};
        this.companyCompositions.forEach((composition) => {
          compositionsMap[composition.id] = composition.name;
        });
        return compositionsMap;
      },
      materialsSlVueTree() {
        return this.$store.getters['materials/materialsSlVueTree'];
      }
    },
    methods: {
      async onSubmit () {
        this.$store.dispatch('submitWaste/saveWizardOutput', this.$router).then(() => {
            this.$snotify.success('Composition saved.');
        });
      },
    },

    async mounted () {
      this.base = this.baseData;
      this.outputSecond = this.outputSecondData;
      this.materials = this.outputSecond.materials.filter((data) => data.material_id);
      this.otherMaterials = this.outputSecond.materials.filter((data) => data.sub_composition_id);
    },

    components: {
      'base-text': BaseText,
      'base-button': BaseButton,
    }
  };

</script>
